// extracted by mini-css-extract-plugin
export default {"loadingScreen":"Loader_loadingScreen__I2p0L"};